$(document).ready(function() {

  $(".moitem_featured summary.parent-link").click(function(){
    //alert('1');
    setTimeout(function(){
      //alert('2');
      $(this).parent('details').find(".sub-menu summary").trigger('click');
    }, 500);
  });

 // Header hover  
$('#header').hover(function() {
  $(this).addClass('active'); // add class when mouseover happen
}, function() {
  $(this).removeClass('active'); // remove class when mouseout happen
});

// Header search
$('.thb-quick-search').click(function() {
  $("#header").toggleClass('active_search'); 
  $(".click-capture").toggleClass('search_overlay'); 
});
$('.click-capture').click(function() {
  $("#header").removeClass('active_search'); 
});
  
// Day / Night change
  /*
$('#theme_mode').click(function() {
  $("#wrapper").toggleClass('light_theme');
  $("#wrapper").toggleClass('dark_mode');
});
 */

  // Search type clear btn show
$("#side-panel-search-input").keypress(function() {
    if($(this).val().length > 1) {
         $(".cl_search").css('opacity', '1');
    } else {
         $(".cl_search").css('opacity', '0');
    }
});
  
  $('.cl_search').click(function(){
   $('#side-panel-search-input').val('');
     $(".cl_search").css('opacity', '0');
    $(".side-panel-content--has-tabs").removeClass('active'); 
    
});

$('#mini-cart-note button').click(function(){
if ($('#mini-cart__notes').is(':empty')){
  $('#order-note-toggle').removeClass('active');
} else {
  $('#order-note-toggle').addClass('active');
}
});  

// mobile menu open header white
$('.mobile-toggle').click(function(){ 
  $('#header').toggleClass('moheader_active');
});  
  
$(".order-note-toggle__content button").click(function(){
  //alert('0');
var inp = $("#mini-cart__notes").val();
if($.trim(inp).length > 0)  {  
  //alert('1');
  $("#order-note-toggle").addClass('active');  

  
    setTimeout(function(){
      //alert('a');
        localStorage.setItem('gift', 'yes');
    }, 50); 
  
} else {
  $("#order-note-toggle").removeClass('active');  
}
});

  
});

/*day-night mode value store in localstorage*/
$(document).ready(function() {
  // Set a value in localStorage
  var currentmode = $("#wrapper").attr('data-mode');
  //alert(currentmode);
  $('#theme_mode').click(function() {
 //   alert('1');
    if($("#wrapper").hasClass('dark_theme')){
    //  alert('2');
      $("#wrapper").addClass('light_theme');
      $("#wrapper").attr('data-mode', 'light');
      $("img#imgplus").attr('src', 'https://houseofharlow1960.com/cdn/shop/t/45/assets/Day-White-desktop.svg');
      $("#header.header-sticky--active").removeClass('black_header');
      setTimeout(function(){
          $("#wrapper").removeClass('dark_theme');
      }, 100);
    } else {
      $("#wrapper").addClass('dark_theme');
      $("#wrapper").attr('data-mode', 'dark');
      $("img#imgplus").attr('src', 'https://houseofharlow1960.com/cdn/shop/t/45/assets/nightmode.svg');
      $("#header.header-sticky--active").addClass('black_header');
      setTimeout(function(){
          $("#wrapper").removeClass('light_theme');
      }, 100);
    }

    setTimeout(function(){
          var clickedcurrentmode = $("#wrapper").attr('data-mode');
          localStorage.setItem('thememode', clickedcurrentmode);
      }, 100);    
  });
  
});

// Retrieve the value from localStorage
$(document).ready(function() {  
  var storedValue = localStorage.getItem('thememode');
  //alert(storedValue);

  var storedGiftValue = localStorage.getItem('gift');
  //alert(storedGiftValue);
  
  if (storedGiftValue == 'yes') {
    $("#order-note-toggle").addClass('active');  
  }
  
  if (storedValue == 'light') {
    // Use the retrieved value
    $("#wrapper").addClass(storedValue+'_theme');
    $("#wrapper").attr('data-mode', storedValue);
    $("#wrapper").removeClass('dark_theme');
    $("img#imgplus").attr('src', 'https://houseofharlow1960.com/cdn/shop/t/45/assets/Day-White-desktop.svg');
    $("#header.header-sticky--active").removeClass('black_header');
    console.log(storedValue); // Outputs: "Hello from Page 1!"
  } else {
    $("#wrapper").addClass('dark_theme');
    $("#wrapper").attr('data-mode', 'dark');
    $("#wrapper").removeClass('light_theme');
    $("img#imgplus").attr('src', 'https://houseofharlow1960.com/cdn/shop/t/45/assets/nightmode.svg');
    $("#header.header-sticky--active").addClass('black_header');
  }
});

$(function() {

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 50) {
            $("#Search-Drawer").addClass("top_min");
        } else {
           $("#Search-Drawer").removeClass("top_min");
        }
    });
 });  

